import { useState } from "react";
import { adminApi } from "../repositories/admin";

export const useCredits = () => {
  const { getAllCreditsForUser } = adminApi;
  const [credits, setCredits] = useState([]);
  const [totalAvailableCredits, setTotalAvailableCredits] = useState(0);
  // Without this the credits list rendered its empty state on the first paint,
  // before the request resolved.
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 20,
    hasNextPage: false,
    hasPreviousPage: false,
  });
  const getAllUserCredits = async ({
    id,
    page = 1,
    limit = 20,
  }: {
    id: number;
    page?: number;
    limit?: number;
  }) => {
    try {
      setLoading(true);
      const response = await getAllCreditsForUser({
        userId: id,
        page,
        limit,
      });

      const responseData = response.data.data;

      setCredits(responseData.allCredits || []);
      setTotalAvailableCredits(responseData.totalAvailableCredits || 0);

      const paginationData = responseData.pagination || {};
      setPagination({
        currentPage: paginationData.page || page,
        totalPages: paginationData.totalPages || 1,
        totalItems: paginationData.totalItems || 0,
        limit: paginationData.limit || limit,
        hasNextPage: paginationData.hasNextPage || false,
        hasPreviousPage: paginationData.hasPreviousPage || false,
      });

    } catch (error) {
      console.error("Error fetching user credits:", error);
    } finally {
      setLoading(false);
    }
  };
  return {
    credits,
    totalAvailableCredits,
    getAllUserCredits,
    pagination,
    loading,
  };
};
